// globalMixin.js
import store from '@/store'; // 引入 Vuex store
import router from '@/router';
import {getspQuest } from '@/api/upload'
import Vue from 'vue';
import assist from '@/utils/commonality';
export default {
  methods: {
    async getNewsign () {
      let newsign =   await getspQuest('/api/cost/bySignInfo','post','17',{
         token:this.$store.getters.isuserInfo.jwt
       })
 
       return  newsign.data.sign
     },
     uploadBeforeBtn() { //登录之前上传文件禁止子元素冒泡
      if (this.$store.getters.isuserInfo.isSign) {
         //如果登录了就判断有没有开通会员
         if (!this.$store.state.userInfo.isVip) {
             //如果开通会员了以后的逻辑

         }
       } else {
         //先判断有没有登录  没有登录让登录
         this.$store.commit("updateloginVisible", true);
       }
     },
     denglupanduan() { //登录的判断
      if (!this.$store.getters.isuserInfo.isSign) {
          this.$store.commit("updateloginVisible", true);
          return 
      }
     },
     vippanduan() { //vip的判断
         if (!this.$store.getters.isuserInfo.isSign) {
              this.$store.commit("updateloginVisible", true);
              return 
          }
          if (!this.$store.getters.isuserInfo.isVip) {
              this.$store.commit('updatispopvip',true)
              return
          }
     },

   async  DownloadRecord(name) {
      await getspQuest(
        '/api/image/saveDownloadRecord',
        'post',
        '23',
        {
          url:name
        }
      )
     }



  }
};